import { MasterConfigTabView } from 'features/master';

const MasterConfigPage = () => <MasterConfigTabView />;

export default MasterConfigPage;
